import React from 'react';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import { SignInButton } from './SignInButton';

export default function Protected({ children }) {
    return (
        <>
        <AuthenticatedTemplate>
            {children}
        </AuthenticatedTemplate>
        <UnauthenticatedTemplate>
            <SignInButton />
            </UnauthenticatedTemplate>
        </>
    );
}